(function(angular) {
    angular.module('wtApp.arrangeTypeInput')
        // Date formats as needed by momentjs and bootstrap date parser
        .constant('COMPLEX_INPUT_UI_DATE_FORMATS', {
            en: {
                day: {
                    moment: 'YYYY-MM-DD',
                    boot: 'yyyy-MM-dd'
                },
                week: {
                    moment: 'YYYY/WW',
                    boot: 'yyyy/WW'
                },
                week_en: {
                    moment: 'YYYY/WW',
                    boot: 'yyyy/WW'
                },
                week_de: {
                    moment: 'YYYY/WW',
                    boot: 'yyyy/WW'
                },
                month: {
                    moment: 'YYYY/MM',
                    boot: 'MMMM yyyy'
                },
                year: {
                    moment: 'YYYY',
                    boot: 'yyyy'
                }
            },
            de: {
                day: {
                    moment: 'DD.MM.YYYY',
                    boot: 'dd.MM.yyyy'
                },
                week: {
                    moment: 'YYYY/WW',
                    boot: 'yyyy/WW'
                },
                week_de: {
                    moment: 'YYYY/WW',
                    boot: 'yyyy/WW'
                },
                week_en: {
                    moment: 'YYYY/WW',
                    boot: 'yyyy/WW'
                },
                month: {
                    moment: 'YYYY/MM',
                    boot: 'MMMM yyyy'
                },
                year: {
                    moment: 'YYYY',
                    boot: 'yyyy'
                }
            },
            zh: {
                day: {
                    moment: 'YYYY-MM-DD',
                    boot: 'yyyy-MM-dd'
                },
                week: {
                    moment: 'YYYY/WW',
                    boot: 'yyyy/WW'
                },
                week_en: {
                    moment: 'YYYY/WW',
                    boot: 'yyyy/WW'
                },
                week_de: {
                    moment: 'YYYY/WW',
                    boot: 'yyyy/WW'
                },
                month: {
                    moment: 'YYYY/MM',
                    boot: 'MMMM yyyy'
                },
                year: {
                    moment: 'YYYY',
                    boot: 'yyyy'
                }
            }
        })
        // Date formats as expected from the API
        .constant('COMPLEX_INPUT_API_DATE_FORMATS', {
            day: 'YYYYMMDD',
            week: 'YYYYWW',
            week_en: 'YYYYWW',
            week_de: 'YYYYWW',
            month: 'YYYYMM',
            year: 'YYYY'
        });
})(window.angular);
